// Sub-estados internos da tela de espera de aprovação de workstation.
//   - WAITING  → aguardando: faz poll do status
//   - SUCCESS  → aprovada: confirmação breve antes de voltar para a senha
//   - TRY_AGAIN → não aprovada (rejeitada/expirada/inexistente): oferece novo pedido
export const PENDING_SUBSTATE = {
  WAITING: 'waiting',
  SUCCESS: 'success',
  TRY_AGAIN: 'tryAgain',
};
